export default "__VITE_ASSET__DnMmCvuf__"